// removed by extract-text-webpack-plugin
module.exports = {"Carrot":"#FB6126","White":"#FFFFFF","notification":"G4181ec G42bbcd","oldDeliveryDay":"G3482b4"};